import { BaseService } from "@/api/services/baseService";
import type { ValidateCaptcha } from "@supplier/entity";
import { customerHttp } from "@/api";

class CustomerMessageService extends BaseService<unknown, unknown, unknown, unknown> {
    public async sendPhoneCode(mobile: string, serialNumber: string) {
        const { data } = await this.service.get(`${this.path}/send/login`, { params: { mobile, serialNumber } });
        return data;
    }
    public async validateCaptcha(params: ValidateCaptcha): Promise<{ code: string; data: boolean }> {
        return await this.service.post(`/captcha/send`, params);
    }
    /* 发送短信验证码（登录页）-忘记密码-用户注册 **/
    public async sendCaptcha(mobile: string) {
        const { data } = await this.service.get(`${this.path}/send/forgot/password`, { params: { mobile } });
        return data;
    }
}

export const customerMessageService = new CustomerMessageService("/msg", customerHttp.service);
